import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';

import { ChevronRightIcon } from '../icons';
import { tokens } from '../theme/tokens';
import { Skeleton } from './Skeleton';
import { IconButton } from './button/IconButton';

const Container = styled(Flex)`
	cursor: pointer;
	padding: ${tokens.padding.container}px;
	gap: ${tokens.gap.group}px;
	align-items: center;

	&:hover {
		background: ${tokens.surface.hover};

		&:active {
			background: ${tokens.surface.secondary};
		}
	}
`;

const Chevron = styled.div`
	flex-shrink: 0;
	pointer-events: none;
`;

const Element = styled(Box)`
	border-bottom: 1px solid ${tokens.border.subtle};

	:last-child {
		border-bottom: 0;
	}
`;

export const ListRow = Skeleton(
	function ListRow(props: PropsWithChildren<BoxProps & { to?: string; onClick?: () => void }>) {
		const container = (
			<Container alignItems="center">
				<Box flexShrink={1} flexGrow={1} minWidth={0}>
					{props.children}
				</Box>
				<Chevron>
					<IconButton type="secondary" icon={<ChevronRightIcon />} />
				</Chevron>
			</Container>
		);

		return (
			<Element data-list-item onClick={props.onClick}>
				{props.to ? <Link to={props.to}>{container}</Link> : container}
			</Element>
		);
	},
	function ListRowSkeleton(props: PropsWithChildren<BoxProps>) {
		return (
			<Element data-list-item>
				<Container alignItems="center">
					<Box flexShrink={1} flexGrow={1} minWidth={0}>
						{props.children}
					</Box>
					<Chevron>
						<IconButton type="secondary" icon={<ChevronRightIcon />} />
					</Chevron>
				</Container>
			</Element>
		);
	},
);

/** @deprecated Use `ListRow`. */
export const PlainCard = ListRow;
